import { Sun } from "lucide-react";

// Theme is locked to light (orange/white). This component is a no-op visual only.
export function ThemeToggle({ className = "" }) {
  return (
    <button
      data-testid="theme-toggle"
      aria-label="Theme: Light"
      title="Orange & White theme"
      className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border border-border text-accent transition-colors hover:bg-elevated ${className}`}
    >
      <Sun className="h-4 w-4" />
    </button>
  );
}
